export default "__VITE_ASSET__054301f6__"